import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from '../../components/loader';

function LedgerReport() {

    const [orderData, setData] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [eDate, setEDate] = useState(today);
    const [sDate, setSDate] = useState(today);
    const [loader, setLoader] = useState(false);

    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

    const formatSendDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const getData = async () => {
        setLoader(true);
        const sendData = {
            sDate: formatSendDate(sDate),
            eDate: formatSendDate(eDate)
        };

        try {
            const response = await axios.post('https://api.trucoo.in/dealers/invoice-report/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            if (response.data.status === "success") {
                setData(response.data.data);
            } else {
                console.log("Error fetching data");
                setData([]); 
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData([]); 
        }
        setLoader(false);
    };

    const getTotal = (orders, type) => {

        if(type === 'amount'){
            let total = 0;
            orders.forEach(order => {
                total += parseFloat(order?.total);
            })
            return total;
        }

        if(type === 'discount'){
            let discount = 0;
            orders.forEach(order => {
                discount += parseFloat(order?.discount);
            })
            return discount;
        }

        if(type === 'milk'){
            let totalMilk = 0;
            orders.forEach(order => {
                order.orderDetails.forEach(item => {
                    if (item.type === "milk") {
                        totalMilk += parseFloat(item.qty) * parseFloat(item.crate) * parseFloat(item.weight/1000);
                    }
                });
            });
            return totalMilk;
        }

        if(type === 'curd'){
            let totalCurd = 0;
            orders.forEach(order => {
                order.orderDetails.forEach(item => {
                    if (item.type === "curd") {
                        totalCurd += parseFloat(item.qty) * parseFloat(item.crate) * parseFloat(item.weight/1000);
                    }
                });
            });
            return totalCurd;
        }

    };

    const exportToExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Daily Sales Report');
        XLSX.writeFile(wb, `Dealers_Report_${formatDate(today)}.xlsx`);
    };

    let invoices = 0;
    let milk = 0;
    let curd = 0;
    let amount = 0;
    let discount = 0;

    return (
        <>
            {loader && <Loader /> }
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                
                                <div className="row" >
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" >
                                        <h4 className="box-title">Dealers Report</h4>
                                        <p className="mb-0 box-subtitle">Invoices</p>
                                    </div>
                                   <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <input
                                            type="date"
                                            value={formatDate(sDate)}
                                            onChange={(e) => setSDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <input
                                            type="date"
                                            value={formatDate(eDate)}
                                            onChange={(e) => setEDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" >
                                        <button class="btn btn-sm btn-success" onClick={getData} >Get Report</button>
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="right">
                                        <button className="btn btn-sm btn-warning" onClick={exportToExcel}><i className="fa fa-download"></i> Excel</button>
                                    </div>
                                </div>
                            </div>
                          
                            <div className="box-body">
                                <div className="table-responsive" style={{width: '100%', height: '65vh', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th width="2%">S.No</th>
                                                <th>Dealer</th>
                                                <th width="5%">Invoices</th>
                                                <th width="7%">Milk LTR</th>
                                                <th width="7%">Curd KG</th>
                                                <th width="7%">Net Total</th>
                                                <th width="7%">Discount</th>
                                                <th width="7%">Grand Total</th>
                                                <th width="5%">View</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderData?.map((item, index) => {

                                                const totalAmount = getTotal(item?.orderData, 'amount');
                                                const totalMilk = getTotal(item?.orderData, 'milk');
                                                const totalCurd = getTotal(item?.orderData, 'curd');
                                                const totalDiscount = getTotal(item?.orderData, 'discount');

                                                invoices += item?.orderData?.length;
                                                milk += totalMilk;
                                                curd += totalCurd;
                                                amount += totalAmount;
                                                discount += totalDiscount;

                                                return (
                                                <tr key={index}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td>{item?.dealer}</td>
                                                    <td className='text-end'>{item?.orderData?.length > 0 && item?.orderData?.length}</td>
                                                    <td className='text-end'>{Number(totalMilk) > 0 && Number(totalMilk).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalCurd) > 0 && Number(totalCurd).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalAmount) > 0 && Number(totalAmount).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalDiscount) > 0 && Number(totalDiscount).toFixed(2)}</td>
                                                    <td className='text-end'>{Number(totalAmount) > 0 && Number(totalAmount - totalDiscount).toFixed(2)}</td>
                                                    <td className='text-center'>
                                                        <a href={`/dealer-reports-details?id=${item?.id}&sDate=${sDate}&eDate=${eDate}`} className="btn btn-sm btn-warning" >View</a>
                                                    </td>
                                                </tr>
                                            )}
                                            )}
                                                <tr>
                                                    <th colspan="2">Total</th>
                                                    <th className='text-end'>{Number(invoices).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(milk).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(curd).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(amount).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(discount).toFixed(2)}</th>
                                                    <th className='text-end'>{Number(amount - discount).toFixed(2)}</th>
                                                    <th></th>
                                                </tr>
                                       </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

        </>
    );
}

export default LedgerReport;